import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SiselseCardsAvailableStatus, SiselseCardsStatus } from 'src/app/enums/siselse.enum';
import { SiselseCardAvailable } from 'src/app/interfaces/siselse';
import { FunctionsService } from 'src/app/services/functions/functions.service';


@Component({
  selector: 'siselse-card-request',  
  styleUrls: ['./card-request.component.scss'],
  templateUrl: './card-request.component.html',
})
export class SiselseCardRequestComponent implements OnInit{
  @Input() card: SiselseCardAvailable;
  @Output() addCardRequest = new EventEmitter<void>();
  status : SiselseCardsAvailableStatus = null;
  constructor(
    public funcServ: FunctionsService

  ) { }

  ngOnInit(){
    this.status = this.getStatus(this.card);
  }
  
  getStatus(card: SiselseCardAvailable): SiselseCardsAvailableStatus {
   // return card.fecha_entrega === "0000-00-00 00:00:00" ? SiselseCardsStatus.EnProceso : SiselseCardsStatus.Entregada;
   if (card.fecha_activacion !== "0000-00-00 00:00:00") {
    return SiselseCardsStatus.Activa;
  } else if (card.fecha_captura !== "0000-00-00 00:00:00") {
    return SiselseCardsStatus.Capturada;
  } 
  }

}